import { FieldWrapper } from '@progress/kendo-react-form';
import React, { useState, useEffect } from 'react';
import FormContainer from '../components/FormContainer';
import config from '../appconfig/config.json';
import Loading from '../components/Loading';
import { useHistory } from 'react-router-dom';
import imgStep from "../images/stepsLOO.png";
import img from '../images/loanOffer.png';
import SubHeader from '../components/SubHeader';
import CusHr from '../components/CusHr';
import CusBbox from '../components/CusBbox';
import helper from '../factory/Helper.js';
import storage from '../factory/StorageFactory';
import CusSavePrint from '../components/CusSavePrint';
import CusCancelApp from '../components/CusCancelApp'
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import CusGreenBtn from '../components/CusGreenBtn'
import service from '../services/StatusEnquiryApiService';
import LofInstructionsPopup from '../components/LofInstructionsPopup';
import StatusEnquiryDtls from '../components/StatusEnquiryDtls';
import LoadingText from '../components/LoadingText';
import LOInstructions from '../components/LOInstructions.jsx';

const ReviewOffer = (props) => {

    let timer;
    const compTypeLL = 'LL', compTypeLC = 'LC', compTypePCLS = 'PCLS';
    const statusExpired = config.StatusDtls.LE;
    const statusUnmaterialised = config.StatusDtls.UM;
    // const statusUnmaterialised = 'LA'
    
    const url_BoardResolution = config.link.BoardReso;

    const pdfExportComponent = React.useRef(null);
    const container = React.useRef(null);
    const [buttonPopup, setButtonPopup] = useState(false);
    const [lofStepsPopup,setLOFStepsPopup] = useState(false);

    const [refNo, setRefNo] = useState('');
    const [uen,setUEN] = useState('');

    const history = useHistory();

    const [response, setResponse] = useState();
    const [isLoading, setIsLoading] = useState(true); //default true;
    const [isLoadingTxt, setIsLoadingTxt] = useState(false);
    const [loadingTxtMsg, setLoadingTxtMsg]=useState('');

    const [isError, setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [lofData,setLofData] = useState('');


    useEffect(() => {
        console.log('@ReviewOffer useEffect');

        window.scrollTo(0, 0);
        getPropsData();

        return () => clearTimeout(timer);
    }, []);
    
    const clearData = () => {
        if (storage.getStateId() !== null) {
            storage.clearAll();
        }
    }

    const getProxyUrl = () => {
        const url = helper.getPdfUrl('Submit');
        return url;
    }

    const exportPDFWithMethod = () => {
        let element = container.current || document.body;
        savePDF(element, {
            paperSize: 'auto',
            margin: 5,
            fileName: refNo + '.pdf',
            proxyUrl: getProxyUrl()
        });
    };

    const exportPDFWithComponent = () => {
        if (pdfExportComponent.current) {
            pdfExportComponent.current.save();
        }
    };

    const printPDF = () => {
        window.print();
    }

    const getPropsData = () => {   //parse form preview or resume application 
        if(props.location.state !== undefined) { //not first time
            let resData = props.location.state.response? props.location.state.response:'';
            setResponse(resData);
            setRefNo(resData.StatusDtls.ApplicationNo);
            setUEN(resData.StatusDtls.UEN);
            setIsLoading(false);
           // getB4StringData(resData.StatusDtls.ApplicationNo);
        }
        else {
             //redirect to error 
        }
    }

  
    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout()
    }

    const setErrMsgTimeout = () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }
     
    const handleContinueBtnClick = () => {
        if(response.Entity_Type_Code === compTypeLL || response.Entity_Type_Code === compTypeLC || response.Entity_Type_Code === compTypePCLS) {
            history.push(config.route.BoardMeetingDate,{from: config.route.ReviewOffer,response:response});
        }  
        else {
            history.push(config.route.LetterOfOffer,{from: config.route.ReviewOffer,response:response}); 
        }
    }

    const showBRDate = () => {
        if(response.Entity_Type_Code === compTypeLL || response.Entity_Type_Code === compTypeLC || response.Entity_Type_Code === compTypePCLS) {
            return true;
        }  
        else {
            return false;
        }
    }

    const showInstructionsPopup = (e) => {
        e.preventDefault();
        setLOFStepsPopup(true);
    }
  
    const onHandleCancelApplication = () => {
           //do cancel api here.
            showLoadingText('Cancelling..');

           service.cancel(refNo,uen).then(res => {
            if (res.data.isSucess) {
                //cancel success
                stopLoadingText();
                setButtonPopup(false);
                props.history.push(config.route.AppCancelled);
            }
        })
        .catch(err => {
            console.log('err: ', err);
            stopLoadingText();
        })
    };

    const showLoadingText = (msg) => {
        setIsLoadingTxt(true);
        setLoadingTxtMsg(msg);
    }

    const stopLoadingText = ()=> {
        setIsLoadingTxt(false);
        setLoadingTxtMsg('');
    }

    const showInterestRateLabel = () => {
        let fType = response.StatusDtls.FinancingType;
       
        if(fType.toLowerCase() === 'conventional') {
            return 'Interest Rate';
        }
        else {
            return 'Profit Rate';
        }
      
    }

    const showLoanReject = () => {
        let status = getStatusCodefromWAA();
        if(status.trim() === statusExpired || status.trim() === statusUnmaterialised) {
            return true;
        }
        else {
            return false;
        }
    }

    const getStatusCodefromWAA = () => {
        const appStatusCode = response.StatusDtls.ApplicationProgress;
        // const array =appStatusCode.split('-');
        let code = appStatusCode;
        return code;
    }

    const handleBacktoHome = (e) => {
        //route url to home screen
        window.location.href = config.link.BacktoHome;
    }
       

    const handleReviewLoanOffer = (e) => {
        e.preventDefault();
        getLetterofOffer();
    }

    const getLetterofOffer = () => {
        showLoadingText('Please wait..')
        service.getLetterOffer(refNo).then( res => {
            stopLoadingText();
            let resData = res.data.model;
            let b64Data= resData.data;
            const dFileName = resData.uen+".pdf";
            let blob = converBase64toBlob(b64Data, 'application/pdf');
            const blobURL = URL.createObjectURL(blob);
           // window.open(blobURL);

            //download pdf, commented 
            const link = document.createElement('a');
            link.href = blobURL;
            link.setAttribute('download', dFileName ); //or any other extension
            document.body.appendChild(link);
            link.click();
        })
        .catch( err => {
            console.log('err: ',err);
            stopLoadingText();
        })
    }


    function converBase64toBlob(content, contentType) {
        contentType = contentType || '';
        let sliceSize = 512;
        let byteCharacters = window.atob(content); //method which converts base64 to binary
        let byteArrays = [
        ];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);
            let byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          let byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
        var blob = new Blob(byteArrays, {
          type: contentType
        }); //statement which creates the blob
        return blob;
      }

    if(isLoading) {
        return(
          <Loading />
        )
    }

    return (
        <>
        {showLoanReject() ?
        <div className="container-fluid">
            <SubHeader title={'Oops!'} />  
            <FormContainer>
                {getStatusCodefromWAA() === statusExpired &&
                <div style={{ fontWeight: "500",paddingTop:'20px', fontSize:'18px'}} className="box inputPair" id={'tt1'}>
                    Your letter of Offer has expired. Do reapply again.
                </div>
                }
                {getStatusCodefromWAA() === statusUnmaterialised &&
                <div style={{fontWeight: "500",paddingTop:'20px', fontSize:'18px'}} className="box inputPair" id={'tt1'}>
                    We are unable to process your application online. Our Relationship Manager will be in touch with you.<br/><br/>
                    For queries, get in touch at<br/>
                    1800-MAYBANK (1800-629 2265) or (65) 6533 5229 (Overseas)
                </div>
                }
                <CusHr style={{ marginTop: '-2em' }} />
                <StatusEnquiryDtls data={response.StatusDtls} />
                <CusHr style={{ marginTop: '-2em' }} />
                <CusBbox id1="interestRate" lb1={"Interest rate (Indicative)"} val1={response.StatusDtls.InterestRate+'%'}
                    id2="instalment" lb2="Instalment (Indicative)" val2={'SGD '+response.StatusDtls.Instalment} />
                <br/>
              
                <CusGreenBtn lbtxt={getStatusCodefromWAA() === statusExpired? 'Reapply SME e-Financing':'Back To Home'} onClick={handleBacktoHome} />
                <br/>
            </FormContainer>
           <br/>
       </div>:
        <PDFExport ref={pdfExportComponent} paperSize="auto" margin={10} fileName={refNo + '.pdf'}>
   
        <div className="container-fluid">
            <SubHeader title={'Letter of Offer'} /> <br />
            <FormContainer>
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <h2 style={{ fontSize: '1.2em' }}>Review Loan Offer</h2><br />
                                  
                    <img className="imgScc" src={img} alt="imgScc"></img><br />
                    {'View '}
                    <a className="txtBlue" href={''} target="_blank" onClick={handleReviewLoanOffer}><u>{'Review Loan Offer'}</u></a><br/>
                </div>
                <FieldWrapper>
                    <CusHr lbtxt="Your loan/financing application has been approved with below details" />

                     <StatusEnquiryDtls data={response.StatusDtls} />              

                    <CusHr style={{ marginTop: '-2em' }} />
                    
                    <CusBbox id1="interestRate" lb1={showInterestRateLabel()} val1={response.StatusDtls.InterestRate+'%'}
                        id2="instalment" lb2="Instalment" val2={'SGD '+response.StatusDtls.Instalment} />
                    
                    <br />

                    {showBRDate() === false?
                    <div>      
                    {/* removed dedoco steps */}
                        {/* <hr className='hrgreyline' /> */}
                        {/* <img src={imgStep} alt="imgScc"></img> */}
                   
                        <br />
                        <CusSavePrint lb1='Save PDF' onClick1={exportPDFWithMethod} lb2='Print PDF' onClick2={printPDF} />
          
                        <CusGreenBtn lbtxt='Continue' onClick={handleContinueBtnClick} />
                        <br/>
                    </div>
                    :
                    <div>
                        <div style={{textAlign:'center', marginLeft:'10px', marginRight:'10px', marginBottom:'10px'}}>
                          
                            <div style={{fontSize:'0.8em'}}>
                                {'The Board Resolutions approving the acceptance of the Letter of Offer must be pass before'}<br/>
                                {'the Letter of Offer can be accepted. Refer to the sample extract of the '}
                                <a className="txtBlue" href={url_BoardResolution} target="_blank" >{'Board Resolution'}</a><br/>
                                {'To proceed please click on "Continue" below.'}
                            </div> 
                         
                            <br/>
                            <CusGreenBtn lbtxt='Continue' onClick={handleContinueBtnClick} style={{width:'8em'}}  /> <br/>
                                {/* <div style={{fontSize:'0.8em'}}>
                                    {'Click here for the '}   
                                        <a className="txtBlue" href={''} target="_blank" onClick={showInstructionsPopup} >{'steps by step Instructions'}</a>
                                    {' on how to accept your Letter of Offer'}
                                </div><br/> */}
                            <CusSavePrint lb1='Save PDF' onClick1={exportPDFWithMethod} lb2='Print PDF' onClick2={printPDF} /><br/>
                        </div>
                    </div>
                    }
           
                    <CusCancelApp onClick={() => setButtonPopup(true)} pTrigger={buttonPopup} psetTrigger={setButtonPopup}
                        backClick={() => setButtonPopup(false)} nextClick={onHandleCancelApplication} />
                    <br />
                </FieldWrapper>
       
            </FormContainer>
            <br />
          
            {/* {showBRDate() && 
                <LofInstructionsPopup className="popUpBox" trigger={lofStepsPopup} setTrigger={setLOFStepsPopup} />
            } */}
        </div>
        <LoadingText show={isLoadingTxt} setShow={setIsLoadingTxt} label={loadingTxtMsg} />
        </PDFExport>
        }
        </>
    )
}

export default ReviewOffer;